import { DataResponse } from './DataResponse';

export class DatosSerieResponse{

    id!:number;
	nombre!:string;
	categoria!:string;
	subcategoria!:string;
	unidad!:string;
	idPeriodicidad!:number;
    descripcionPeriodicidad!:string;

	categoriaNivel1!:string;
	categoriaNivel2!:string;
	categoriaNivel3!:string;

	ajusteEstacional!:string;
	base!:string;
	fichaTecnica!:string[];
	fuente!:string;
	fechaInicial!:string;
	fechaFinal!:string;
	notas!:string;
	descripcion!:string;

	fechaUltimoCargue!:string;
	geografia!:string;
	precio!:string;
	periodoReferencia!:string;

	listaSubCategoria!:DatosSerieResponse[];
    data!:DataResponse[];
    
    seleccionado!:boolean;
    seleccionParcial!:boolean;

	isSerie!:string;
	tieneHijos!:string;
}